<template>
    <h2
        class="double-ranking-title"
        :style="{
            color,
            fontSize,
        }"
    >
        {{ content }} {{ fullYear }}
    </h2>
</template>

<script>
import { mediaQueriesMixin } from '@/mixins/mediaQueries';

export default {
    name: 'DoubleRankingTitle',
    mixins: [mediaQueriesMixin],
    props: {
        content: {
            type: String,
            default: '',
        },
        year: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fullYear: this.year ? new Date().getFullYear() : '',
            fontSize: null,
            color: this.getPartnerNameTextColor(),
        };
    },
    mounted() {
        this.fontSize = this.reducePixel(this.getHeroTitleTextSize());
    },
    methods: {
        reducePixel(prop) {
            if (prop.includes('px')) {
                const pixel = parseFloat(prop.replace('px', '')) - 2;
                return `${pixel}px`;
            }

            return prop;
        },
        getHeroTitleTextSize() {
            try {
                const heroType =
                    this.$globalConstants.components['CategoryPage'][
                        'heroType'
                    ];

                const banner = this.$globalConstants.components[heroType];

                if (banner['titleDesktopFontSize'] && this.isDesktop()) {
                    return banner['titleDesktopFontSize'];
                }

                if (banner['titleMobileFontSize']) {
                    return banner['titleMobileFontSize'];
                }
            } catch (e) {
                console.warn(e);
            }

            return '';
        },
        getPartnerNameTextColor() {
            try {
                const partnerType =
                    this.$globalConstants.components['CategoryPage'][
                        'partnerRowType'
                    ];

                const partner = this.$globalConstants.components[partnerType];

                if (partner['partnerNameTextColor']) {
                    return partner['partnerNameTextColor'];
                }
            } catch (e) {
                console.warn(e);
            }
            return null;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@/sass/mixins';

.double-ranking-title {
    text-align: left;
    width: 100%;
    padding-bottom: 25px;
    font-size: 20px;
    color: #333;

    @include mq('tablet') {
        font-size: 27px;
    }
}
</style>
